import { Box, Tab, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import { TabsChildren } from "./utils/enums/tabs"
import { SyntheticEvent, useEffect, useState } from "react"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { useInput } from "../../utils/hooks/useInput"
import { AddUsers } from "./components/addUsers"
import { PermissionAsssignment } from "./components/permissionAssignment"
import { useTables } from "../../utils/hooks/useTable"
import { useGetData } from "../../utils/hooks/getData"
import { useFilter } from "../../utils/hooks/useFilter"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import { useContextState } from "../../../../../../hooks/theme"
import { SnackSimple } from "../../../../../../components"
import { submit } from "./utils/methods"
import { Types } from '../../../../../../utils/enums'



export const Access = () => {
  const { t } = useTranslation()
  const styles = useStyles()
  const [userSelected, setUserSelected] = useState<Record<string, boolean>>({})

  const { colors } = useContextState()

  const [value, setValue] = useState(TabsChildren.USERS)
  const handleChange = (_: SyntheticEvent | null, newValue: TabsChildren) => {
    setValue(newValue)
  }

  const { loadingTable, userTable, dataEndpoint, } = useGetData()

  const { input, createFilter, permissionFilter, dataUsers, setDataUsers, cancelSearchUsers, searchUsers, modalLoad, loadUsers, inputFilter, loadings, snackbar, closeSnackbar, setSnackbar } = useInput({ setUserSelected, userSelected })

  const { filterRow } = useFilter()


  const {
    column: columnFolio,
    row: rowFolio,
    openModal,
    userFolioSelected,
    closeModal,
    setAllUsers,
    rowFiltered,
    setAllSettingsFolioUser,
    deleteSelected,
    deletedUsersSelecteds,
    setDeletedSelected,
    usersToDelete
  } = useTables({ tab: value, userTable, dataUsers, setUserSelected, userSelected, dataFilter: permissionFilter.filterData, filterRow })

  const [submitLoading, setSubmitLoading] = useState(false)


  const unselectOrSelectAllUserFoliosManage = ({ value }: { value: boolean }) => {
    let body: Record<
      string,
      {
        webAccess?: boolean
        mobileAccess?: boolean
        seeReport?: boolean
        resendReport?: boolean
      }
    > = structuredClone(userFolioSelected)

    const filter = filterRow({ list: rowFolio, value: permissionFilter.filterData })

    filter?.forEach((item) => {
      body = {
        ...body,
        [item.id?.toString() ?? '']: {
          ...userFolioSelected[item.id?.toString() ?? ''],
          mobileAccess: value,
          resendReport: value,
          seeReport: value,
          webAccess: value
        },
      }
    })

    return { body, filter }
  }

  const unSelectOrSelectAllUsersFolios = ({ value }: { value: boolean }) => {
    const { body, filter } = unselectOrSelectAllUserFoliosManage({ value })
    setAllSettingsFolioUser({ userFolio: body, skip: !value, filter })
  }


  const getInitialValues = () => {

    let body: Record<string, boolean> = {}
    let bodyFolio: Record<
      string,
      {
        webAccess?: boolean
        mobileAccess?: boolean
        seeReport?: boolean
        resendReport?: boolean
      }
    > = {}

    dataEndpoint?.forEach((itemUsers) => {

      bodyFolio = {
        ...bodyFolio,
        [itemUsers.userId]: {
          ...bodyFolio[itemUsers.userId],
          webAccess: !!itemUsers?.accessWeb,
          mobileAccess: !!itemUsers?.accessMobile,
          seeReport: !!itemUsers?.accessShowReport,
          resendReport: !!itemUsers?.accessResendReport
        },
      }

      body = {
        ...body,
        [itemUsers.userId]: true,
      }
    })

    setAllSettingsFolioUser({ userFolio: bodyFolio, skip: true })

    if (!!Object.values(body)?.length) {
      setAllUsers({ newSelected: body })
    }

  }

  const handleSubmit = () => {
    setSubmitLoading(true)
    submit({ userFolioSelected: userFolioSelected, userSelected, usersToDelete })
      .then((response) => {
        if (!response?.errors) {
          /* navigate(`/dashboard/organization-chart/departments/edit/${id ?? response.id}`) */
          setSnackbar(prev => ({ ...prev, type: Types.SUCCESS, message: t('loogbook.snackbar.success'), open: true }))
          /* handleChange(null, payload?.finish ? TabDepartment.FOLIO : TabDepartment.USER) */
        } else {
          setSnackbar(prev => ({ ...prev, type: Types.ERROR, message: t('loogbook.snackbar.error'), open: true }))
        }
      })
      .finally(() => {
        setSubmitLoading(false)
      })
  }

  useEffect(() => {
    getInitialValues()
  }, [userTable?.length, dataEndpoint?.length])

  useEffect(() => {
    setDataUsers(prevDataUsers => {
      const updatedUsers = [...prevDataUsers];

      dataEndpoint.forEach(endpoint => {
        const existingUserIndex = updatedUsers.findIndex(user => user.id === endpoint.userId);

        if (existingUserIndex !== -1) {
          updatedUsers[existingUserIndex] = {
            area: endpoint.area,
            department: endpoint.department,
            id: endpoint.userId,
          };
        } else {
          updatedUsers.push({
            area: endpoint.area,
            department: endpoint.department,
            id: endpoint.userId,
          });
        }
      });

      return updatedUsers;
    });
  }, [dataEndpoint])

  return (
    <Box>
      <Typography variant="title_grey_big">{t('loogbook.titles.logbookTable')}</Typography>
      <Box sx={styles.tabsContainer}>
        <TabContext value={value}>
          <TabList sx={[styles.TabList]} onChange={handleChange} centered>
            <Tab label={t('loogbook.tabsChildren.addUsers').toUpperCase()} value={TabsChildren.USERS} />
            <Tab label={t('loogbook.tabsChildren.permissions').toUpperCase()} value={TabsChildren.PERMISSIONS} />
          </TabList>

          <TabPanel value={TabsChildren.USERS} sx={styles.TabPanel}>
            <AddUsers
              cleanFilter={() => { createFilter.cleanFilter() }}
              counter={createFilter.counter ?? 0}
              lastStep={1}
              rigthItem={<DinamicForm input={Object.values(input)} onChange={createFilter.onChange} errors={createFilter.errors} values={createFilter.filterData} />}
              userList={modalLoad?.tmpUsuers as Record<string, string>[]}
              open={false}
              close={cancelSearchUsers}
              userAmount={modalLoad?.tmpUsuers?.length ?? 0}
              searchButton={{
                disabled: !createFilter.query?.filter,
                loading: !!loadings.search,
                onClick: searchUsers
              }}
              addMessage
              loadData={{
                loading: !!loadings.load,
                onClick: loadUsers
              }}
            />
          </TabPanel>

          <TabPanel value={TabsChildren.PERMISSIONS} sx={styles.TabPanel}>
            <PermissionAsssignment
              loadingTable={loadingTable}
              submitLoading={submitLoading}
              handleSubmit={handleSubmit}
              deleteSelected={deleteSelected}
              deletedUsersSelecteds={deletedUsersSelecteds}
              setDeletedSelected={setDeletedSelected}
              floatItems={<DinamicForm input={Object.values(inputFilter)} values={permissionFilter.filterData} onChange={permissionFilter.onChange} errors={permissionFilter.errors} filter={true} />}
              cleanFilter={permissionFilter.cleanFilter}
              counter={permissionFilter.counter}
              rowFiltered={rowFiltered}
              columnFolio={columnFolio}
              unSelectOrSelectAllUsersFolios={unSelectOrSelectAllUsersFolios}
            />
          </TabPanel>
        </TabContext>
      </Box>
      <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />
      <SimpleModal
        open={openModal.open}
        close={() => {
          closeModal()
        }}
        title={openModal.title}
        description={openModal.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        color={colors}
        back={() => {
          closeModal()
        }}
        next={() => {
          if (openModal?.confirm) {
            openModal.confirm()
          }
        }}
      />
    </Box>
  )
}